import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const p = category ? { category } : {};
    api.get("/products", { params: p })
      .then((r) => setProducts(r.data))
      .finally(() => setLoading(false));
  }, [category]);

  const tabs = [
    { key: "", label: "All" },
    { key: "shirts", label: "Shirts" },
    { key: "stickers", label: "Stickers" },
  ];

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12">
      <p className="text-[#C5A059] text-xs font-bold uppercase tracking-[0.3em] mb-2">The Collection</p>
      <h1 className="font-heading text-5xl font-900 uppercase tracking-tight mb-8">Shop Gear</h1>

      <div className="flex gap-2 mb-10 border-b border-white/10">
        {tabs.map((t) => (
          <button key={t.key} data-testid={`shop-tab-${t.label.toLowerCase()}`}
            onClick={() => t.key ? setParams({ category: t.key }) : setParams({})}
            className={`px-5 py-3 text-sm font-semibold uppercase tracking-wider transition-colors border-b-2 -mb-px ${
              category === t.key ? "text-white border-[#E63946]" : "text-[#A1A1AA] border-transparent hover:text-white"
            }`}>
            {t.label}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-[#A1A1AA] py-20 text-center">Loading gear…</p>
      ) : products.length === 0 ? (
        <p className="text-[#A1A1AA] py-20 text-center" data-testid="shop-empty">No products found.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6" data-testid="shop-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
